import { MSKU_OPTION_UNAVAILABLE_LABEL } from '../constants/createSendSummary';
import { IMarketplaceItem, IMarketplaceSKUOption } from '../types/marketplace';

export type TMarketplaceVariantStock = Partial<Pick<IMarketplaceSKUOption, 'count'>>;

export type TMarketplaceStockSource = Partial<Pick<IMarketplaceItem, 'count'>> & {
  sku_options?: TMarketplaceVariantStock[] | null;
};

export const isMarketplaceVariantOutOfStock = ({ count }: TMarketplaceVariantStock): boolean => !(count && count > 0);

export const isMarketplaceItemOutOfStock = ({ count, sku_options }: TMarketplaceStockSource): boolean =>
  sku_options?.length ? sku_options.every(isMarketplaceVariantOutOfStock) : isMarketplaceVariantOutOfStock({ count });

export const getMarketplaceStockCount = ({ count, sku_options }: TMarketplaceStockSource): number =>
  sku_options?.length
    ? sku_options.reduce((total, option) => total + Math.max(0, option.count ?? 0), 0)
    : Math.max(0, count ?? 0);

export const formatMarketplaceStock = (count: number): string => `${count} in stock`;

export const getMarketplaceStockLabel = (source: TMarketplaceStockSource): string => {
  const count = getMarketplaceStockCount(source);

  return count > 0 ? formatMarketplaceStock(count) : MSKU_OPTION_UNAVAILABLE_LABEL;
};
